<template>
    <div class="min-h-screen flex flex-col">
      <div class="flex-grow">
        <router-view />
      </div>
  
      <!-- <footer class="py-4 bg-white shadow">
        <div class="container mx-auto px-4 flex justify-center">
          <p class="text-sm text-gray-600">
            &copy; {{ currentYear }} SellHub. Tous droits réservés.
          </p>
        </div>
      </footer> -->
    </div>
  </template>
  
  <script>
  import { defineComponent, computed } from 'vue'
  
  export default defineComponent({
    name: 'AuthLayout',
    
    setup() {
      const currentYear = computed(() => new Date().getFullYear())
      
      return {
        currentYear
      }
    }
  })
  </script>